import { unsafeCSS } from 'lit';

export const FdsTypographyUiLabelFontFamily = /*#__PURE__*/ unsafeCSS(
  "var(--fds-typography-ui-label-font-family, 'Public Sans', 'PublicSans-Medium')",
);
export const FdsTypographyUiLabelFontSize = /*#__PURE__*/ unsafeCSS(
  'var(--fds-typography-ui-label-font-size, 16px)',
);
export const FdsTypographyUiLabelLetterSpacing = /*#__PURE__*/ unsafeCSS(
  'var(--fds-typography-ui-label-letter-spacing, 0px)',
);
export const FdsTypographyUiLabelLineHeight = /*#__PURE__*/ unsafeCSS(
  'var(--fds-typography-ui-label-line-height, 22px)',
);
export const FdsTypographyUiLabelFontWeight = /*#__PURE__*/ unsafeCSS(
  'var(--fds-typography-ui-label-font-weight, 500)',
);
export const FdsTypographyUiLabelDisplay = /*#__PURE__*/ unsafeCSS(
  'var(--fds-typography-ui-label-display, inline-block)',
);

export const FdsColorBrandBlack = /*#__PURE__*/ unsafeCSS(
  'var(--fds-color-brand-black, #000000)',
);
export const FdsColorBrandWhite = /*#__PURE__*/ unsafeCSS(
  'var(--fds-color-brand-white, #ffffff)',
);
export const FdsColorNeutral100 = /*#__PURE__*/ unsafeCSS(
  'var(--fds-color-neutral-100, #cdcdd7)',
);
export const FdsColorNeutral300 = /*#__PURE__*/ unsafeCSS(
  'var(--fds-color-neutral-300, #505064)',
);
export const FdsColorText300 = /*#__PURE__*/ unsafeCSS(
  'var(--fds-color-text-300, #9696aa)',
);
